import { render } from "./ModalFooter.vue?vue&type=template&id=576a2de2&scoped=true"
import script from "./ModalFooter.vue?vue&type=script&lang=js"
export * from "./ModalFooter.vue?vue&type=script&lang=js"

import "./ModalFooter.vue?vue&type=style&index=0&id=576a2de2&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576a2de2"]])

export default __exports__